import { Row, Col, Card, Input, Form, Divider } from 'antd';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { dodCredentialsConfig } from './formConfig';

const
config = dodCredentialsConfig,
{ key } = config,
{ generateFormItem, generateInputComponent } = ssFormUtils,
{ validateForm, validateSubForm } = ssFormValidationUtils,
EMAIL_FIELD = 'emailAddress',
VERIFY_EMAIL = 'verifyEmailAddress',
VERIFY_MESSAGE = 'Email addresses must match';

export default class DodCredentials extends React.Component {
    constructor(props) { super(props); }

    componentDidUpdate(prevProps) {
        const
        { services, registrationForm } = this.props,
        currForm = registrationForm[key],
        prevForm = prevProps.registrationForm[key],
        { storeForm } = services;

        if(!ssCommonUtils.simpleObjectCompare(prevForm, currForm)) {
            const formState = validateForm(currForm, config, true);
            storeForm(key, formState);
            this.setState({ isValid: this.verifyEmail(this.props) && validateSubForm(formState) });
        }
    }

    verifyEmail(nextProps) {
        const form = nextProps.registrationForm[key];

        if(form[VERIFY_EMAIL] && form[EMAIL_FIELD])
            if (form[VERIFY_EMAIL] === form[EMAIL_FIELD]) {
                this.setEmailVerificationError(false);
                return true;
            }

        this.setEmailVerificationError(true);
        return false;
    }

    setEmailVerificationError(inError) {
        const
        { storeFormField } = this.props.services;
        storeFormField(key, `${VERIFY_EMAIL}_help`, inError ? VERIFY_MESSAGE : '');
        storeFormField(key, `${VERIFY_EMAIL}_status`, inError ? 'error' : 'success');
    }

    render() {
        const
        { services, registrationForm } = this.props,
        { storeFormField, storeForm } = services,
        form = registrationForm[key];
        return (
            <div>
                <Row type='flex' justify='center' style={{ marginBottom: '20px' }}>
                    <Col span={20}>
                        <Card
                            hoverable
                            bodyStyle={{ padding: '20px 20px 20px 20px' }}
                            style={{ cursor: 'default' }}
                        >
                            <div style={{ textAlign: 'left', marginBottom: '10px' }}>
                                {'Please choose a User ID and enter a valid email address. This email address '}
                                {'will be used to send you your login information, so make sure it is valid and '}
                                {'you have access to it. '}
                            </div>
                            <Divider type='horizontal'>
                                <span style={{ color: 'grey', fontSize: '11px', fontWeight: 'bold', fontStyle: 'italic' }}>
                                    {'Info'}
                                </span>
                            </Divider>
                            <ul>
                                <li>
                                    <div style={{ textAlign: 'left' }}>
                                        {'This User ID will be linked to your account, and will be used for other agencies, '}
                                        {'such as fingerprinting, and CANNOT be changed.'}
                                    </div>
                                </li>
                            </ul>
                        </Card>
                    </Col>
                </Row>
                <Row type='flex' justify='center'>
                    <Col span={23}>
                        <Row gutter={12} type='flex' justify='center'>
                            <Col span={5}>
                                <Form.Item {...generateFormItem('userId', config, form)}>
                                    <Input {...{...generateInputComponent('userId', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                            <Col span={5}>
                                <Form.Item {...generateFormItem('emailAddress', config, form)}>
                                    <Input {...{...generateInputComponent('emailAddress', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                            <Col span={5}>
                                <Form.Item {...generateFormItem('verifyEmailAddress', config, form)}>
                                    <Input {...{...generateInputComponent('verifyEmailAddress', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}
